import type { EntryMeta } from '~/types'
import VimeoEmbed from '~/components/gallery/VimeoEmbed'
import LoopingVideo from '~/components/gallery/LoopingVideo'
import type { MediaPath } from '~/generated/media'

const cover = 'portfolio/ae_dreams_mockup3.jpg' satisfies MediaPath

// TODO: encode portfolio/vger.gif to mp4/webm and sync to R2; these paths don't exist yet.
const trajectoryMp4 = '/media/vger.mp4'
const trajectoryWebm = '/media/vger.webm'
const trajectoryPoster = '/media/vger-poster.jpg'

export const meta: EntryMeta = {
	slug: 'voyager',
	name: 'Voyager',
	excerpt: 'Experiments, waves, dust on slate',
	tags: ['video', 'motion'],
	cover,
	order: 50,
}

export default function Voyager() {
	return (
		<>
			<p>
				Memories cast into the unknown. Space into space, time around time — one system in perpetual
				flux, hung in balance against its own inertia. Hosted on Vimeo; the player loads on demand.
			</p>
			<VimeoEmbed id="76979871" poster={cover} title="Voyager" />
			<figure className="mt-8">
				<LoopingVideo
					mp4={trajectoryMp4}
					webm={trajectoryWebm}
					poster={trajectoryPoster}
					alt="Voyager trajectory timeline, 1977 onward"
				/>
				<figcaption className="mt-2 text-sm opacity-70">
					Trajectory timeline — an animated study of the mission's path out of the system.
				</figcaption>
			</figure>
		</>
	)
}
